import QuackBehavior from './QuackBehavior';

class MuteQuack extends QuackBehavior {
  quack() {
    //Don't do nothing!
  }
}

export default MuteQuack;
